module.exports = __webpack_public_path__ + "img/mobile.0c64d830.png";